module.exports = __webpack_public_path__ + "media/images/course/depo_03-1e37c45e9168646ac240237c530f46ba.png";